export default __webpack_public_path__ + "static/darkVector-a031aec55348a4c74b524c62a93d71e3.png";